const startMarkerIconStyle = {
    path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
    fillColor: "green",
    fillOpacity: 1
}
const pastMarkerStyle = {
    path: "M 0 -3 C 0 -3 0 -3 0 -3 C 9 -3 9 11 0 11 C -8 11 -9 -3 0 -3",
    fillColor: "gray",
    fillOpacity: 1,


}
const currentMarkerStyle = {
    path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
    fillColor: "red",
    fillOpacity: 1
}

export { startMarkerIconStyle, pastMarkerStyle, currentMarkerStyle }